export default __webpack_public_path__ + "img/marker-icon-3-07daa52f3dd50b84ceac1ebc84c1e1d7.svg";